
let basePath = "";
if (process.env.NODE_ENV === "development") {
    basePath = "/base";
}

const baseurl = (window.baseurl || basePath) + "";
const urls = {
    //各学院报到情况统计
    getxueyuantongji: baseurl + "/_web/_apps/freshmanRegistration/api/digitizing/departmentSignIn.rst",
    //按时间段报到情况统计
    gettimeTongji: baseurl + "/_web/_apps/freshmanRegistration/api/digitizing/signInPeriod.rst",
    //专业报到TOP10，已按照报到人数排好序，页面获取前10条即可
    getzhuanyetop: baseurl + "/_web/_apps/freshmanRegistration/api/digitizing/specialtySignInTop.rst",
    //整体报到情况统计
    getall: baseurl + "/_web/_apps/freshmanRegistration/api/digitizing/wholeSignIn.rst"
}


export default urls